var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-block" }, [
    _vm.bookingIsMine
      ? _c("h2", [_vm._v("My Details")])
      : _c("h2", [
          _vm._v(
            _vm._s(!_vm.booking.is_offer ? _vm.$t("Client") : `Requestor`) +
              " Details"
          ),
        ]),
    _vm._v(" "),
    _vm.booking && _vm.booking.client
      ? _c("div", { staticClass: "form-item__row" }, [
          _vm.userCanSeeClientBasicDetails
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Name"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "form-control",
                        attrs: { id: "name" },
                        on: { copy: _vm.handleCopy },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.booking.client.name) +
                            "\n\n          "
                        ),
                        _vm.$userIsAdmin
                          ? [
                              _vm._v("\n            -\n            "),
                              _vm.$userIsAdmin
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        tag: "a",
                                        to: {
                                          name: "clients.profile.show",
                                          params: { id: _vm.booking.client.id },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Profile\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v("\n            |\n            "),
                              _vm.$userIsAdmin
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        tag: "a",
                                        to: {
                                          name: "clients.requests.index",
                                          params: {
                                            clientId: _vm.booking.client.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Requests\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v("\n            |\n            "),
                              _vm.$userIsAdmin
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        tag: "a",
                                        to: {
                                          name: "clients.bookings.index",
                                          params: {
                                            clientId: _vm.booking.client.id,
                                          },
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              Bookings\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-item__field" }, [
            _c(
              "div",
              { staticClass: "input-group input-group-booking-detail" },
              [
                _c("span", { staticClass: "input-group-addon" }, [
                  _vm._v(
                    _vm._s(_vm._f("sentenceCase")(_vm.$t("organisation")))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "form-control",
                    attrs: { id: "company" },
                    on: { copy: _vm.handleCopy },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("nullable")(_vm.booking.client.company)) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.booking.client.department
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v(
                        _vm._s(_vm._f("sentenceCase")(_vm.$t("department")))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "form-control",
                        attrs: { id: "company" },
                        on: { copy: _vm.handleCopy },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("nullable")(_vm.booking.client.department)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeClientBasicDetails && _vm.userCanSeeClientPii
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Email"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "form-control",
                        attrs: { id: "email" },
                        on: { copy: _vm.handleCopy },
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: `mailto:${_vm.booking.client.email}`,
                            },
                          },
                          [_vm._v(_vm._s(_vm.booking.client.email))]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeClientBasicDetails && _vm.userCanSeeClientPii
            ? _c("div", { staticClass: "form-item__field" }, [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Phone"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "form-control",
                        attrs: { id: "phone" },
                        on: { copy: _vm.handleCopy },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("nullable")(
                              _vm._f("phoneNumber")(
                                _vm.booking.client.phone,
                                _vm.booking.region
                                  ? _vm.booking.region.shortname
                                  : null
                              )
                            )
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userCanSeeClientDiscoveryDetails &&
          _vm.booking.client.found_pickstar
            ? _c(
                "div",
                { staticClass: "form-item__field form-item__field--row" },
                [
                  _c(
                    "div",
                    { staticClass: "input-group input-group-booking-detail" },
                    [
                      _c("span", { staticClass: "input-group-addon" }, [
                        _vm._v("Found " + _vm._s(_vm.clientName)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "form-control" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.foundPickstarOptions.findIndex(
                                (element) =>
                                  element.id ===
                                  _vm.booking.client.found_pickstar
                              ) !== -1
                                ? _vm.foundPickstarOptions.find(
                                    (element) =>
                                      element.id ===
                                      _vm.booking.client.found_pickstar
                                  ).text
                                : _vm.booking.client.found_pickstar
                            ) +
                            "\n          " +
                            _vm._s(
                              _vm.booking.client.other_found_pickstar
                                ? " - " +
                                    _vm.booking.client.other_found_pickstar
                                : ""
                            )
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.userCanSeeClientPii
            ? _c("div", { staticClass: "form-item__row" }, [
                this.bookingTypeIsBooking && this.findClientThread()
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n          To speak to the client about this booking, use our "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "#drawer-messages-chat",
                              "data-toggle": _vm.$chatsModuleEnabled
                                ? "drawer"
                                : null,
                              "aria-foldedopen": "false",
                              "aria-controls": "drawer-messages-chat",
                            },
                            on: { click: _vm.handleGetThreadCallback },
                          },
                          [_vm._v(" chat feature ")]
                        ),
                        _vm._v(". Alternatively, contact Pickstar.\n        "),
                      ]),
                    ])
                  : _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n          Once the client has paid, speak to them directly via our chat. If you have any issues contact Pickstar.\n        "
                        ),
                      ]),
                    ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }